module.exports = __webpack_public_path__ + "static/purchase-paper-10c510312d3fe39feee95eb0d34df978.png";